import React from 'react';
import { Wave } from 'react-animated-text';

export const Wave1 = () => (
    <Wave text="Karan Gupta" effect="stretch" effectChange={2.0} />
);
